import { ChevronDown, ChevronUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface ExpandCollapseToggleProps {
  expanded: boolean;
  onToggle: () => void;
  expandLabel?: string;
  collapseLabel?: string;
  className?: string;
}

export function ExpandCollapseToggle({
  expanded,
  onToggle,
  expandLabel = "View all",
  collapseLabel = "Collapse",
  className,
}: ExpandCollapseToggleProps) {
  const Icon = expanded ? ChevronUp : ChevronDown;
  return (
    <Button
      variant="ghost"
      size="sm"
      className={cn("h-9 w-full py-2 text-xs", className)}
      onClick={onToggle}
    >
      <Icon className="h-4 w-4 mr-1" />
      {expanded ? collapseLabel : expandLabel}
    </Button>
  );
}
